module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-code"
  }, [_c('pre', {
    staticClass: "demo-code-pre"
  }, [_c('code', {
    ref: "code",
    class: _vm.lang
  }, [_vm._v(_vm._s(_vm.code.trim()))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a22f75f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/v-code.vue
// module id = 687
// module chunks = 0